export interface MySubscriptionProject {
    license_with_key_id?: number;
    job_number?: string;
    address?: string;
    subscription_id?: number;
    project_start_date?: string;
    project_end_date?: string;
    this_project_active?: 1 | 0;
}

// to single object maping
export const mapMySubscriptionProject = (data:any): MySubscriptionProject => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: MySubscriptionProject ={
        license_with_key_id: data.license_with_key_id,
        job_number: data.job_number,
        address: data.address,
        subscription_id: data.subscription_id,
        project_start_date: data.project_start_date,
        project_end_date: data.project_end_date,
        this_project_active: data.this_project_active,
    }
    return res;
}

// maping list objects
export const mapMySubscriptionProjects = (data:any[]): MySubscriptionProject[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapMySubscriptionProject);
}